import { useMount } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import ResponsiveImage from '../../parts/ResponsiveImage';
import ImageZoom from 'react-image-zooom';
import { getVariantFromURL, buildGalleryImages } from './utils';

const ProductSpecsGallery = ({ data, isFetching, defaultvariant }) => {
  const [galleryImages, setGalleryImages] = useState([]);

  useMount(() => {
    window.theme_app.on('selectedVariant', (state) => {
      let galleryImages = buildGalleryImages({ images: data.product.images, variant: getVariantFromURL() || parseInt(defaultvariant) });
      setGalleryImages(galleryImages);
    });
  });

  useEffect(() => {
    if (!isFetching && data.product?.images) {
      let galleryImages = buildGalleryImages({ images: data.product.images, variant: getVariantFromURL() || parseInt(defaultvariant) });
      setGalleryImages(galleryImages);
    }
  }, [data, isFetching]);

  if (!galleryImages.length) {
    return null;
  }

  let referenceImage = galleryImages[1] || galleryImages[0];

  if (!referenceImage) {
    return null;
  }

  return (
    <div>
      <ResponsiveImage image={referenceImage.src} title={referenceImage.alt || data.product.title}></ResponsiveImage>
    </div>
  );
};

const GalleryProvider = (props) => {
  const { data, isFetching } = useQuery(
    'product',
    async () => {
      return await fetch(`${window.location.origin}/${window.location.pathname}.json`).then((res) => res.json());
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  if (!data || isFetching) {
    return null;
  }

  return <ProductSpecsGallery {...props} data={data} isFetching={isFetching} />;
};

export default GalleryProvider;
